import type { CookieConsent } from './types'
import { useSyncExternalStore } from 'react'
import { cookieConsentClient, DEFAULT_COOKIE_CONSENT } from './cookieConsentClient'

export function useCookieConsent(client = cookieConsentClient): CookieConsent {
  return useSyncExternalStore(client.subscribe, client.getCookieConsent, () => DEFAULT_COOKIE_CONSENT)
}
